var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"radialBar","height":_vm.height,"options":_vm.chartOptions,"series":_vm.data,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }